import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getAdminAlerts: query({
        query: () => "/admin/alerts",
        providesTags: ["AdminAlerts"],
        // ✅ poll every 30s for real-time badge updates
        pollingInterval: 30000,
      }),

      toggleAlertRead: mutation({
        query: (id) => ({
          url: `/admin/alerts/${id}/toggle-read`,
          method: "PATCH",
        }),
        invalidatesTags: ["AdminAlerts"], // refresh list
      }),
    };
  },
});

export const { useGetAdminAlertsQuery, useToggleAlertReadMutation } =
  adminApiSlice;
